"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_popper_1 = require("react-popper");
const React = require("react");
const Popover_1 = require("./Popover");
class PopoverContainer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const Fragment = React.Fragment;
        const { id, children, popoverProps, targetParent, onClick, style } = this.props;
        return (React.createElement(Fragment, null,
            React.createElement(react_popper_1.Manager, null,
                React.createElement(react_popper_1.Reference, null, ({ ref }) => (React.createElement("div", { ref: ref, id: id, onClick: e => {
                        e.stopPropagation();
                        onClick();
                    }, style: Object.assign({ display: 'inline-block' }, style) }, children[0]))),
                this.props.showPopover && (React.createElement(Popover_1.default, Object.assign({}, popoverProps, { toggle: onClick, targetParent: targetParent }), children[1])))));
    }
}
exports.default = PopoverContainer;
